import { z } from 'zod';

/** The client roles of anchor-loop ADR 0022 §4 an invitation may carry. Team roles are given in Loop, never by email. */
export const GuestInvitationRole = z.enum(['client_contributor', 'client_lead', 'client_trusted']);
export type GuestInvitationRole = z.infer<typeof GuestInvitationRole>;

export const CreateGuestInvitationRequest = z.object({
  email: z.email().max(254),
  name: z.string().trim().min(1).max(120),
  role: GuestInvitationRole.default('client_contributor'),
}).strict();
export const RedeemGuestInvitationRequest = z.object({ id: z.uuid(), secret: z.string().regex(/^[A-Za-z0-9_-]{43}$/), email: z.email().max(254) }).strict();
export const GuestInvitation = z.object({
  id: z.uuid(), email: z.email(), name: z.string(), createdAt: z.string(), expiresAt: z.string(),
  role: GuestInvitationRole,
  status: z.enum(['pending', 'accepted', 'revoked']), deliveryStatus: z.enum(['pending', 'sent', 'failed']),
  /** Yard has the request but John or Adam has not approved the person yet; no link has been sent. */
  waiting: z.boolean(),
});
export type GuestInvitation = z.infer<typeof GuestInvitation>;
